import { otherRowModeSelectKey } from './utils/otherComponentMode'

const hemisphereMap = {
  // If in both, use north - Source https://gist.github.com/tadast/8827699
  AF: 'north',
  AL: 'north',
  DZ: 'north',
  AS: 'south',
  AD: 'north',
  AO: 'south',
  AI: 'north',
  AQ: 'south',
  AG: 'north',
  AR: 'south',
  AM: 'north',
  AW: 'north',
  AU: 'south',
  AT: 'north',
  AZ: 'north',
  BS: 'north',
  BH: 'north',
  BD: 'north',
  BB: 'north',
  BY: 'north',
  BE: 'north',
  BZ: 'north',
  BJ: 'north',
  BM: 'north',
  BT: 'north',
  BO: 'south',
  BQ: 'north',
  BA: 'north',
  BW: 'south',
  BV: 'south',
  BR: 'south',
  IO: 'south',
  BN: 'north',
  BG: 'north',
  BF: 'north',
  BI: 'south',
  KH: 'north',
  CM: 'north',
  CA: 'north',
  CV: 'north',
  KY: 'north',
  CF: 'north',
  TD: 'north',
  CL: 'south',
  CN: 'north',
  CX: 'south',
  CC: 'south',
  CO: 'north',
  KM: 'south',
  CD: 'north',
  CG: 'south',
  CK: 'south',
  CR: 'north',
  CI: 'north',
  HR: 'north',
  CU: 'north',
  CW: 'north',
  CY: 'north',
  CZ: 'north',
  DK: 'north',
  DJ: 'north',
  DM: 'north',
  DO: 'north',
  EC: 'south',
  EG: 'north',
  SV: 'north',
  GQ: 'north',
  ER: 'north',
  EE: 'north',
  ET: 'north',
  FK: 'south',
  FO: 'north',
  FJ: 'south',
  FI: 'north',
  FR: 'north',
  GF: 'north',
  PF: 'south',
  TF: 'south',
  GA: 'south',
  GM: 'north',
  GE: 'north',
  DE: 'north',
  GH: 'north',
  GI: 'north',
  GR: 'north',
  GL: 'north',
  GD: 'north',
  GP: 'north',
  GU: 'north',
  GT: 'north',
  GG: 'north',
  GW: 'north',
  GN: 'north',
  GY: 'north',
  HT: 'north',
  HM: 'south',
  VA: 'north',
  HN: 'north',
  HK: 'north',
  HU: 'north',
  IS: 'north',
  IN: 'north',
  ID: 'south',
  IR: 'north',
  IQ: 'north',
  IE: 'north',
  IM: 'north',
  IL: 'north',
  IT: 'north',
  JM: 'north',
  JP: 'north',
  JE: 'north',
  JO: 'north',
  KZ: 'north',
  KE: 'south',
  KI: 'south',
  KP: 'north',
  KR: 'north',
  XK: 'north',
  KW: 'north',
  KG: 'north',
  LA: 'north',
  LV: 'north',
  LB: 'north',
  LS: 'south',
  LR: 'north',
  LY: 'north',
  LI: 'north',
  LT: 'north',
  LU: 'north',
  MO: 'north',
  MK: 'north',
  MG: 'south',
  MW: 'south',
  MY: 'north',
  MV: 'north',
  ML: 'north',
  MT: 'north',
  MH: 'north',
  MQ: 'north',
  MR: 'north',
  MU: 'south',
  YT: 'south',
  MX: 'north',
  FM: 'north',
  MD: 'north',
  MC: 'north',
  MN: 'north',
  ME: 'north',
  MS: 'north',
  MA: 'north',
  MZ: 'south',
  MM: 'north',
  NA: 'south',
  NR: 'south',
  NP: 'north',
  NL: 'north',
  NC: 'south',
  NZ: 'south',
  NI: 'north',
  NE: 'north',
  NG: 'north',
  NU: 'south',
  NF: 'south',
  MP: 'north',
  NO: 'north',
  OM: 'north',
  PK: 'north',
  PW: 'north',
  PS: 'north',
  PA: 'north',
  PG: 'south',
  PY: 'south',
  PE: 'south',
  PH: 'north',
  PN: 'south',
  PL: 'north',
  PT: 'north',
  PR: 'north',
  QA: 'north',
  RE: 'south',
  RO: 'north',
  RU: 'north',
  RW: 'south',
  BL: 'north',
  SH: 'south',
  KN: 'north',
  LC: 'north',
  MF: 'north',
  PM: 'north',
  VC: 'north',
  WS: 'south',
  SM: 'north',
  ST: 'south',
  SA: 'north',
  SN: 'north',
  RS: 'north',
  SC: 'south',
  SL: 'north',
  SG: 'north',
  SX: 'north',
  SK: 'north',
  SI: 'north',
  SB: 'south',
  SO: 'north',
  ZA: 'south',
  GS: 'south',
  ES: 'north',
  LK: 'north',
  SD: 'north',
  SR: 'north',
  SJ: 'north',
  SZ: 'south',
  SE: 'north',
  CH: 'north',
  SY: 'north',
  TW: 'north',
  TJ: 'north',
  TZ: 'south',
  TH: 'north',
  TL: 'south',
  TG: 'north',
  TK: 'south',
  TO: 'south',
  TT: 'north',
  TN: 'north',
  TR: 'north',
  TM: 'north',
  TC: 'north',
  TV: 'south',
  UG: 'south',
  UA: 'north',
  AE: 'north',
  GB: 'north',
  UM: 'north',
  US: 'north',
  UY: 'south',
  UZ: 'north',
  VU: 'south',
  VE: 'north',
  VN: 'north',
  VG: 'north',
  VI: 'north',
  WF: 'south',
  EH: 'north',
  YE: 'north',
  ZM: 'south',
  ZW: 'south',
}

function getHemisphereFromCountry(iso2) {
  return hemisphereMap[iso2.toUpperCase()] || 'north'
}

const azimuthDefaultsMap: Record<string, { azimuth_from: string | null; azimuth_to: string | null }> = {
  GB: {
    azimuth_from: '30',
    azimuth_to: '330',
  },
}

const defaultAzimuthDefaults = {
  azimuth_from: null,
  azimuth_to: null,
}

export const getAzimuthDefaultsFromCountryIso2 = (
  countryIso2: string
): { azimuth_from: string | null; azimuth_to: string | null } => {
  return azimuthDefaultsMap[countryIso2.toUpperCase()] || defaultAzimuthDefaults
}

export const getHemisphereBasedAzimuthDefaults = (
  countryIso2: string
): { azimuth_from: string; azimuth_to: string } => {
  const hemisphere = getHemisphereFromCountry(countryIso2)

  if (hemisphere === 'north') {
    return {
      azimuth_from: '80',
      azimuth_to: '280',
    }
  } else {
    return {
      azimuth_from: '260',
      azimuth_to: '100',
    }
  }
}

export const parseSettingsFromJSON = (settingsJSON) => {
  if (!settingsJSON) return {}

  try {
    return typeof settingsJSON === 'string' ? JSON.parse(settingsJSON) : settingsJSON
  } catch (error) {
    return {}
  }
}

export const validateAzimuth = (value) => {
  if (!value || value === '') {
    return undefined
  }
  const numValue = parseInt(value)
  if (isNaN(numValue) || numValue < 0 || numValue > 360) {
    return 'Azimuth must be between 0 and 360 degrees'
  }
  return undefined
}

const safeNumberToString = (value: any): string => {
  return value !== null && value !== undefined ? value.toString() : ''
}

const safeParseNumber = (value: any, parser: (str: string) => number = parseFloat): number | null => {
  if (value === null || value === undefined || value === '') {
    return null
  }
  const parsed = parser(value.toString())
  return isNaN(parsed) ? null : parsed
}

function serializeSettingsComponentRow(component: any): Record<string, any> {
  const code = String(component.code).trim()
  const qtyRaw = component.quantity
  const modeKey = otherRowModeSelectKey(component.quantity_mode)
  const isOtherScaled = component.component_type === 'other' && Boolean(modeKey)

  const quantity = isOtherScaled ? 0 : parseInt(String(qtyRaw), 10) || 1

  const row: Record<string, any> = {
    code,
    quantity,
    component_type: component.component_type,
  }
  if (isOtherScaled) {
    row.quantity_mode = modeKey
    if (component.mode_step != null && component.mode_step !== '') {
      const s = Number(component.mode_step)
      if (!Number.isNaN(s)) row.mode_step = s
    }
    if (component.quantity_multiplier != null && component.quantity_multiplier !== '') {
      const m = Number(component.quantity_multiplier)
      if (!Number.isNaN(m)) row.quantity_multiplier = m
    }
    if (component.mode_code != null && String(component.mode_code).trim() !== '') {
      row.mode_code = String(component.mode_code).trim()
    }
  }
  return row
}

function serializeComponentsAndQuantitiesForSettingsPayload(components: any[]): Record<string, any>[] | undefined {
  const filtered = components.filter((c) => c?.code && String(c.code).trim() !== '')
  if (filtered.length === 0) return undefined
  return filtered.map(serializeSettingsComponentRow)
}

export const getTemplateAnalyticsData = (values) => {
  return {
    templateName: values.name,
    templateDescription: values.description,
    designType: values.settings_object?.design_type,
    calculatorId: values.calculator_id,

    hasComponents: values.components_and_quantities?.length > 0,
    componentCount: values.components_and_quantities?.length || 0,
    componentTypes:
      values.components_and_quantities?.map((c) => c.component_type).filter((v, i, a) => a.indexOf(v) === i) || [],

    enableDesignRules: values.settings_object?.enable_design_rules,
    hasAzimuthConstraints: !!(
      values.settings_object?.azimuth_constraint?.from && values.settings_object?.azimuth_constraint?.to
    ),
    hasConstraints: !!(
      values.settings_object?.annual_kwh_constraint?.min ||
      values.settings_object?.annual_kwh_constraint?.max ||
      values.settings_object?.consumption_offset_percentage_constraint?.min ||
      values.settings_object?.consumption_offset_percentage_constraint?.max ||
      values.settings_object?.module_quantity_constraint?.min ||
      values.settings_object?.module_quantity_constraint?.max ||
      values.settings_object?.system_kw_constraint?.min ||
      values.settings_object?.system_kw_constraint?.max
    ),

    batteryDesignAssistantEnabled: values.settings_object?.battery_design_assistant_enabled,
    batterySelectionMode: values.settings_object?.battery_selection_mode,
    inverterDesignAssistantEnabled: values.settings_object?.inverter_design_assistant_enabled,
    inverterSelectionMode: values.settings_object?.inverter_selection_mode,

    autoApplyMounting: values.settings_object?.autoApplyKeys?.mounting,
    autoApplyPricing: values.settings_object?.autoApplyKeys?.pricing_scheme,
    autoApplyIncentives: values.settings_object?.autoApplyKeys?.incentives_override,
    autoApplyAdders: values.settings_object?.autoApplyKeys?.adders_override,
    autoApplyPaymentOptions: values.settings_object?.autoApplyKeys?.payment_options_override,

    source: 'system_template_form',
    action: values.id ? 'template_updated' : 'template_created',
  }
}

export const parseInitialValues = (record) => {
  if (!record) {
    return getDefaultValues(null)
  }

  const { settings, mounting_config, ...values_verbatim } = record
  const parsedSettings = parseSettingsFromJSON(settings)
  const parsedMountingConfig = parseSettingsFromJSON(mounting_config)

  // Extract fields that need special handling
  const {
    constraints,
    components_and_quantities,
    azimuth_from_to,
    battery_design_assistant,
    inverter_design_assistant,
    ...settings_verbatim
  } = parsedSettings

  // Transform constraints into more accessible constraint objects
  const annual_kwh_constraint = constraints?.find((c) => c.type === 'annual_kwh') || {
    type: 'annual_kwh',
    min: null,
    max: null,
  }
  const consumption_offset_percentage_constraint = constraints?.find(
    (c) => c.type === 'consumption_offset_percentage'
  ) || {
    type: 'consumption_offset_percentage',
    min: null,
    max: null,
  }
  const module_quantity_constraint = constraints?.find((c) => c.type === 'module_quantity') || {
    type: 'module_quantity',
    min: null,
    max: null,
  }
  const module_quantity_per_array_constraint = constraints?.find((c) => c.type === 'module_quantity_per_array') || {
    type: 'module_quantity_per_array',
    min: null,
    max: null,
  }
  const system_kw_constraint = constraints?.find((c) => c.type === 'kw') || { type: 'kw', min: null, max: null }

  const isFullCircleNoConstraint =
    Array.isArray(azimuth_from_to) &&
    azimuth_from_to.length === 2 &&
    ((azimuth_from_to[0] === 0 && azimuth_from_to[1] === 360) ||
      (azimuth_from_to[0] === 360 && azimuth_from_to[1] === 0) ||
      (azimuth_from_to[0] === 0 && azimuth_from_to[1] === 0))
  const azimuth_constraint = isFullCircleNoConstraint
    ? { from: null, to: null }
    : {
        from: azimuth_from_to?.[0] !== undefined ? azimuth_from_to[0] : null,
        to: azimuth_from_to?.[1] !== undefined ? azimuth_from_to[1] : null,
      }

  // Ensure components_and_quantities exists
  const components = components_and_quantities || []

  // Handle battery design assistant
  const battery_design_assistant_enabled =
    parsedSettings.battery_design_assistant_enabled !== undefined
      ? parsedSettings.battery_design_assistant_enabled
      : false
  const battery_selection_mode = parsedSettings.battery_selection_mode
  let battery_codes: string[] = []

  if (battery_design_assistant_enabled && battery_selection_mode !== 'disabled_clear_all' && battery_design_assistant) {
    battery_codes =
      typeof battery_design_assistant.codes === 'string'
        ? battery_design_assistant.codes
            .split(',')
            .map((c) => c.trim())
            .filter(Boolean)
        : Array.isArray(battery_design_assistant.codes)
          ? battery_design_assistant.codes
          : []

    // Ensure all BDA codes are present in components
    battery_codes.forEach((code) => {
      if (!components.some((c) => c.code === code)) {
        components.push({ code, quantity: 0, component_type: 'battery' })
      }
    })
  } else if (battery_selection_mode !== 'disabled_clear_all') {
    battery_codes = components.filter((c) => c.component_type === 'battery' && c.code).map((c) => c.code)
  }

  // Handle inverter design assistant
  const inverter_design_assistant_enabled =
    parsedSettings.inverter_design_assistant_enabled !== undefined
      ? parsedSettings.inverter_design_assistant_enabled
      : false
  const inverter_selection_mode = parsedSettings.inverter_selection_mode
  let inverter_codes: string[] = []

  if (
    inverter_design_assistant_enabled &&
    inverter_selection_mode !== 'disabled_clear_all' &&
    inverter_design_assistant
  ) {
    inverter_codes =
      typeof inverter_design_assistant.codes === 'string'
        ? inverter_design_assistant.codes
            .split(',')
            .map((c) => c.trim())
            .filter(Boolean)
        : Array.isArray(inverter_design_assistant.codes)
          ? inverter_design_assistant.codes
          : []

    // Ensure all IDA codes are present in components
    inverter_codes.forEach((code) => {
      if (!components.some((c) => c.code === code)) {
        components.push({ code, quantity: 0, component_type: 'inverter' })
      }
    })
  } else if (inverter_selection_mode !== 'disabled_clear_all') {
    inverter_codes = components.filter((c) => c.component_type === 'inverter' && c.code).map((c) => c.code)
  }

  // Get Auto Apply Keys
  let autoApplyKeys = parsedSettings.autoApplyKeys

  if (!autoApplyKeys) {
    autoApplyKeys = {
      mounting: mounting_config?.mounting_id !== undefined && mounting_config?.mounting_id !== null,
      pricing_scheme: values_verbatim.pricing_scheme === undefined || values_verbatim.pricing_scheme === null,
      incentives_override:
        values_verbatim.incentives_override === undefined ||
        values_verbatim.incentives_override === null ||
        values_verbatim.incentives_override.length === 0,
      adders_override:
        values_verbatim.adders_override === undefined ||
        values_verbatim.adders_override === null ||
        values_verbatim.adders_override.length === 0,
      payment_options_override:
        values_verbatim.payment_options_override === undefined ||
        values_verbatim.payment_options_override === null ||
        values_verbatim.payment_options_override.length === 0,
      costing_override: values_verbatim.costing_override === undefined || values_verbatim.costing_override === null,
      commission_override:
        values_verbatim.commission_override === undefined || values_verbatim.commission_override === null,
      battery_control_scheme_override:
        values_verbatim.battery_control_scheme_override === undefined ||
        values_verbatim.battery_control_scheme_override === null,
    }
  }
  let kwh_per_kw_min: { value: number | null | undefined; unit: string } = {
    value: null,
    unit: 'per_year',
  }
  if (parsedSettings.kwh_per_kw_min && parsedSettings.kwh_per_kw_min !== null) {
    kwh_per_kw_min = {
      value: parsedSettings.kwh_per_kw_min.value ?? null,
      unit: parsedSettings.kwh_per_kw_min.unit || 'per_year',
    }
  }

  // Create settings_object with nested structure
  const settings_object = {
    ...settings_verbatim,
    annual_kwh_constraint,
    consumption_offset_percentage_constraint,
    module_quantity_constraint,
    module_quantity_per_array_constraint,
    system_kw_constraint,
    azimuth_constraint,
    battery_design_assistant: battery_design_assistant || {},
    inverter_design_assistant: inverter_design_assistant || {},
    battery_selection_mode: battery_selection_mode,
    inverter_selection_mode: inverter_selection_mode,
    battery_codes,
    inverter_codes,
    autoApplyKeys,
    include_buildable_panels: parsedSettings.include_buildable_panels ?? false,
    kwh_per_kw_min,
  }

  return {
    ...values_verbatim,
    mounting_config: parsedMountingConfig,
    settings_object,
    components_and_quantities: components,
    battery_codes,
    inverter_codes,
  }
}

export const getDefaultValues = (record, countryIso2 = 'US') => {
  const { azimuth_from, azimuth_to } = getAzimuthDefaultsFromCountryIso2(countryIso2)

  const defaultValues = {
    name: '',
    description: '',
    calculator_id: 0,
    auto_populate_panels: true,
    settings: '{}',
    // ComponentSelectorInput reads directly from this field
    components_and_quantities: [],
    // Settings object with nested structure
    settings_object: {
      // Design configuration
      enable_design_rules: false,
      design_type: 'set_annual_kwh_energy_offset',
      // Azimuth constraint object
      azimuth_constraint: {
        from: azimuth_from,
        to: azimuth_to,
      },
      orientation_options: null,
      include_buildable_panels: false,
      // Panel production minimum
      kwh_per_kw_min: {
        value: null,
        unit: 'per_year',
      },
      // Constraint objects
      annual_kwh_constraint: { type: 'annual_kwh', min: null, max: null },
      consumption_offset_percentage_constraint: { type: 'consumption_offset_percentage', min: null, max: 100 }, //Set this as default
      module_quantity_constraint: { type: 'module_quantity', min: null, max: null },
      module_quantity_per_array_constraint: { type: 'module_quantity_per_array', min: null, max: null },
      system_kw_constraint: { type: 'kw', min: null, max: null },
      // Battery Design Assistant
      battery_design_assistant_enabled: false,
      battery_selection_mode: 'disabled',
      battery_design_assistant: {
        customer_goal: 'self_consumption',
        backup_hours: 0,
        continuous_power: 0,
        peak_power: 0,
        codes: '',
      },
      battery_codes: [],
      // Inverter Design Assistant
      inverter_design_assistant_enabled: false,
      inverter_selection_mode: 'disabled',
      inverter_design_assistant: {
        inverter_type: 'string',
        codes: '',
      },
      inverter_codes: [],
      autoApplyKeys: {
        mounting: false,
        pricing_scheme: true,
        incentives_override: true,
        adders_override: true,
        payment_options_override: true,
        costing_override: true,
        commission_override: true,
        battery_control_scheme_override: true,
      },
    },
  }

  return defaultValues
}

// Helper function to format submit values - converts form inputs to JSON settings
export const formatSubmitValues = (values) => {
  const { settings_object, components_and_quantities, ...values_verbatim } = values
  let mounting_config = values.mounting_config

  if (!settings_object) {
    return values
  }

  const autoPopulatePanels = values_verbatim.auto_populate_panels !== false

  const {
    annual_kwh_constraint,
    consumption_offset_percentage_constraint,
    module_quantity_constraint,
    module_quantity_per_array_constraint,
    system_kw_constraint,
    azimuth_constraint,
    battery_design_assistant,
    inverter_design_assistant,
    battery_selection_mode,
    inverter_selection_mode,
    battery_codes,
    inverter_codes,
    orientation_options,
    include_buildable_panels,
    kwh_per_kw_min,
    ...settings_verbatim
  } = settings_object

  const settings: any = {
    ...settings_verbatim,
  }

  if (orientation_options && orientation_options !== '' && orientation_options !== null) {
    settings.orientation_options = orientation_options
  }

  if (include_buildable_panels !== undefined) {
    settings.include_buildable_panels = include_buildable_panels
  }

  if (kwh_per_kw_min && kwh_per_kw_min.value !== null && kwh_per_kw_min.value !== undefined) {
    const kwh_per_kw_min_value = safeParseNumber(kwh_per_kw_min.value, parseFloat)
    if (kwh_per_kw_min_value !== null) {
      settings.kwh_per_kw_min = {
        value: kwh_per_kw_min_value,
        unit: kwh_per_kw_min.unit || 'per_year',
      }
    }
  }

  if (settings_object.inverter_selection_mode !== undefined) {
    settings.inverter_selection_mode = settings_object.inverter_selection_mode
  }
  if (settings_object.battery_selection_mode !== undefined) {
    settings.battery_selection_mode = settings_object.battery_selection_mode
  }

  if (settings_object.autoApplyKeys) {
    settings.autoApplyKeys = settings_object.autoApplyKeys
  }

  const serializedComponents = serializeComponentsAndQuantitiesForSettingsPayload(
    Array.isArray(components_and_quantities) ? components_and_quantities : []
  )
  if (serializedComponents) {
    settings.components_and_quantities = serializedComponents
  }

  // Handle azimuth constraint. Only set azimuth_from_to when the user has an explicit constrained range.
  // When blank, partial, or full-circle (0–360 / 360–0 / 0–0), omit the field so the backend and
  // downstream UI (e.g. SystemTemplateTooltipContent) treat it as "All orientations".
  if (azimuth_constraint && azimuth_constraint.from !== null && azimuth_constraint.to !== null) {
    const fromValue = safeParseNumber(azimuth_constraint.from, parseInt)
    const toValue = safeParseNumber(azimuth_constraint.to, parseInt)
    if (fromValue !== null && toValue !== null) {
      const isFullCircle =
        (fromValue === 0 && toValue === 360) ||
        (fromValue === 360 && toValue === 0) ||
        (fromValue === 0 && toValue === 0)
      if (!isFullCircle) {
        settings.azimuth_from_to = [fromValue, toValue]
      }
    }
  }

  // Build constraints array
  const constraints: Array<{
    type: string
    min: number | null
    max: number | null
  }> = []

  // Define which constraints are allowed for each design type
  const allowedConstraintsByDesignType = {
    set_system_size: ['kw', 'module_quantity_per_array'],
    max_fit: ['module_quantity_per_array'], // Only advanced constraints
    set_module_qty: ['module_quantity', 'module_quantity_per_array'],
    set_annual_kwh: ['annual_kwh', 'module_quantity_per_array'],
    set_annual_kwh_energy_offset: ['consumption_offset_percentage', 'module_quantity_per_array'],
  }

  // Get allowed constraint types for this design type
  const designType = settings.design_type
  const allowedTypes = allowedConstraintsByDesignType[designType] || []

  // Only add constraints that are allowed for the current design type
  if (
    allowedTypes.includes('annual_kwh') &&
    annual_kwh_constraint &&
    (annual_kwh_constraint.min !== null || annual_kwh_constraint.max !== null)
  ) {
    const minValue = safeParseNumber(annual_kwh_constraint.min)
    const maxValue = safeParseNumber(annual_kwh_constraint.max)
    if (minValue !== null || maxValue !== null) {
      constraints.push({
        type: 'annual_kwh',
        min: minValue,
        max: maxValue,
      })
    }
  }

  if (
    allowedTypes.includes('consumption_offset_percentage') &&
    consumption_offset_percentage_constraint &&
    (consumption_offset_percentage_constraint.min !== null || consumption_offset_percentage_constraint.max !== null)
  ) {
    const minValue = safeParseNumber(consumption_offset_percentage_constraint.min)
    const maxValue = safeParseNumber(consumption_offset_percentage_constraint.max)
    if (minValue !== null || maxValue !== null) {
      constraints.push({
        type: 'consumption_offset_percentage',
        min: minValue,
        max: maxValue,
      })
    }
  }

  if (
    allowedTypes.includes('module_quantity') &&
    module_quantity_constraint &&
    (module_quantity_constraint.min !== null || module_quantity_constraint.max !== null)
  ) {
    const minValue = safeParseNumber(module_quantity_constraint.min, parseInt)
    const maxValue = safeParseNumber(module_quantity_constraint.max, parseInt)
    if (minValue !== null || maxValue !== null) {
      constraints.push({
        type: 'module_quantity',
        min: minValue,
        max: maxValue,
      })
    }
  }

  if (
    allowedTypes.includes('module_quantity_per_array') &&
    module_quantity_per_array_constraint &&
    (module_quantity_per_array_constraint.min !== null || module_quantity_per_array_constraint.max !== null)
  ) {
    const minValue = safeParseNumber(module_quantity_per_array_constraint.min, parseInt)
    const maxValue = safeParseNumber(module_quantity_per_array_constraint.max, parseInt)
    if (minValue !== null || maxValue !== null) {
      constraints.push({
        type: 'module_quantity_per_array',
        min: minValue,
        max: maxValue,
      })
    }
  }

  if (
    allowedTypes.includes('kw') &&
    system_kw_constraint &&
    (system_kw_constraint.min !== null || system_kw_constraint.max !== null)
  ) {
    const minValue = safeParseNumber(system_kw_constraint.min)
    const maxValue = safeParseNumber(system_kw_constraint.max)
    if (minValue !== null || maxValue !== null) {
      constraints.push({
        type: 'kw',
        min: minValue,
        max: maxValue,
      })
    }
  }

  if (constraints.length > 0) {
    settings.constraints = constraints
  }

  // If panels are not being auto-populated, force module_quantity to 0 and remove panel-sizing constraints.
  // This avoids templates failing validation due to default design-type constraints (e.g. energy offset).
  if (!autoPopulatePanels) {
    settings.design_type = 'set_module_qty'
    settings.constraints = [{ type: 'module_quantity', min: 0, max: 0 }]
  }

  // Handle Battery Design Assistant
  if (
    settings.battery_design_assistant_enabled &&
    battery_selection_mode !== 'disabled_clear_all' &&
    battery_design_assistant
  ) {
    const batteryCodes = Array.isArray(settings.components_and_quantities)
      ? settings.components_and_quantities.filter((c) => c.component_type === 'battery' && c.code).map((c) => c.code)
      : battery_codes || []

    settings.battery_design_assistant = {
      customer_goal: battery_design_assistant.customer_goal || 'self_consumption',
      backup_hours: safeParseNumber(battery_design_assistant.backup_hours) || 0,
      continuous_power: safeParseNumber(battery_design_assistant.continuous_power) || 0,
      peak_power: safeParseNumber(battery_design_assistant.peak_power) || 0,
      codes: batteryCodes.join(','),
    }

    settings.battery_selection_mode = battery_selection_mode || 'enabled'

    // Remove batteries with codes handled by the battery design assistant, but only if batteryCodes is not empty
    if (
      settings.components_and_quantities &&
      Array.isArray(settings.components_and_quantities) &&
      batteryCodes.length > 0
    ) {
      settings.components_and_quantities = settings.components_and_quantities.filter(
        (c) => c.component_type !== 'battery' || !batteryCodes.includes(c.code)
      )
    }
  }

  // Handle disabled_clear_all for battery - ensure no batteries are included
  if (battery_selection_mode === 'disabled_clear_all') {
    if (settings.components_and_quantities) {
      settings.components_and_quantities = settings.components_and_quantities.filter(
        (c) => c.component_type !== 'battery'
      )
    }
  }

  // Handle Inverter Design Assistant
  if (
    settings.inverter_design_assistant_enabled &&
    inverter_selection_mode !== 'disabled_clear_all' &&
    inverter_design_assistant
  ) {
    const inverterCodes = Array.isArray(settings.components_and_quantities)
      ? settings.components_and_quantities.filter((c) => c.component_type === 'inverter' && c.code).map((c) => c.code)
      : inverter_codes || []

    settings.inverter_design_assistant = {
      inverter_type: inverter_design_assistant.inverter_type || 'string',
      codes: inverterCodes.join(','),
    }

    settings.inverter_selection_mode = inverter_selection_mode || 'enabled'

    // Remove inverters with codes handled by the inverter design assistant, but only if inverterCodes is not empty
    if (
      settings.components_and_quantities &&
      Array.isArray(settings.components_and_quantities) &&
      inverterCodes.length > 0
    ) {
      settings.components_and_quantities = settings.components_and_quantities.filter(
        (c) => c.component_type !== 'inverter' || !inverterCodes.includes(c.code)
      )
    }
  }

  if (inverter_selection_mode === 'disabled_clear_all') {
    if (settings.components_and_quantities) {
      settings.components_and_quantities = settings.components_and_quantities.filter(
        (c) => c.component_type !== 'inverter'
      )
    }
  }

  let finalValues = { ...values_verbatim }
  const shouldClearPricing = settings_object?.autoApplyKeys?.pricing_scheme === true
  const shouldClearIncentives = settings_object?.autoApplyKeys?.incentives_override === true
  const shouldClearAdders = settings_object?.autoApplyKeys?.adders_override === true
  const shouldClearPaymentOptions = settings_object?.autoApplyKeys?.payment_options_override === true
  const shouldClearCosting = settings_object?.autoApplyKeys?.costing_override === true || shouldClearPricing
  const shouldClearBatteryControlScheme = settings_object?.autoApplyKeys?.battery_control_scheme_override === true
  const isMarkupPercentage = settings_object?.selectedPricingScheme?.pricing_formula === 'Markup Percentage'
  const shouldClearCommission = settings_object?.autoApplyKeys?.commission_override === true
  const shouldClearMounting = settings_object?.autoApplyKeys?.mounting === false

  if (shouldClearPricing) {
    finalValues = { ...finalValues, pricing_scheme: '' }
  }

  if (shouldClearIncentives) {
    finalValues = { ...finalValues, incentives_override: [] }
  }

  if (shouldClearAdders) {
    finalValues = { ...finalValues, adders_override: [] }
  }

  if (shouldClearPaymentOptions) {
    finalValues = { ...finalValues, payment_options_override: [] }
  }

  if (shouldClearCosting || !isMarkupPercentage) {
    finalValues = { ...finalValues, costing_override: '' }
  }

  if (shouldClearCommission) {
    finalValues = { ...finalValues, commission_override: '' }
  }

  if (shouldClearBatteryControlScheme) {
    finalValues = { ...finalValues, battery_control_scheme_override: '' }
  }

  if (shouldClearMounting) {
    mounting_config = null
  }

  // Pack settings and remove settings_object to avoid payload bloat
  const result = {
    ...finalValues,
    mounting_config: JSON.stringify(mounting_config),
    settings: JSON.stringify(settings),
  }

  return result
}
